import { render, staticRenderFns } from "./DeclarationCotisationCacobathPage.vue?vue&type=template&id=25a5688b&scoped=true&"
import script from "./DeclarationCotisationCacobathPage.vue?vue&type=script&lang=js&"
export * from "./DeclarationCotisationCacobathPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a5688b",
  null
  
)

export default component.exports